export default function Content() {
  const mainFeatures = [
    'Cuentos y reflexiones que enseñan el valor de la autenticidad',
    'Ejercicios prácticos para fortalecer la autoestima y la empatía',
    'Actividades familiares que fomentan la unión y la comunicación emocional',
    'Herramientas de inteligencia emocional explicadas de forma sencilla y cercana',
    'Espacios para escribir y reflexionar, donde los niños pueden expresar lo que sienten con libertad'
  ];

  return (
    <section id="content" className="py-12 sm:py-16 md:py-24 px-4 sm:px-6 bg-gradient-to-b from-amber-50 to-orange-50">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col lg:flex-row gap-6 sm:gap-8 md:gap-12 mb-8 sm:mb-12 md:mb-16">
          <div className="lg:w-1/2">
            <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
              📘 ¿Qué encontrarás<br />
              dentro del ebook?
            </h2>
          </div>
          <div className="lg:w-1/2 flex items-center">
            <p className="text-base sm:text-lg md:text-xl text-gray-800 leading-relaxed font-medium">
              Cada capítulo está diseñado para que padres e hijos vivan juntos un proceso de autodescubrimiento, fortaleciendo su vínculo emocional.
            </p>
          </div>
        </div>

        {/* Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 sm:gap-8">
          {/* Main Feature Card */}
          <div className="lg:col-span-5 bg-emerald-50 rounded-2xl sm:rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all">
            <div className="h-48 sm:h-56 md:h-64">
              <img
                src="https://public.readdy.ai/ai/img_res/8875f87045b21d33a687adcf1317f9e5.jpg"
                alt="Cuentos y reflexiones"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-6 sm:p-8">
              <h3 className="font-serif text-xl sm:text-2xl font-bold text-gray-900 mb-4 sm:mb-6">
                Cuentos y reflexiones
              </h3>
              <ul className="space-y-3 sm:space-y-4">
                {mainFeatures.map((feature, index) => (
                  <li key={index} className="flex items-start gap-2 sm:gap-3">
                    <span className="text-emerald-600 text-lg sm:text-xl mt-0.5 font-bold">✔️</span>
                    <span className="text-gray-800 leading-relaxed text-sm sm:text-base font-medium">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Side Cards */}
          <div className="lg:col-span-7 grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">
            {/* For Children Card */}
            <div className="bg-white rounded-2xl sm:rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all hover:scale-105">
              <div className="p-6 sm:p-8 text-center">
                <h3 className="font-serif text-2xl sm:text-3xl font-bold text-gray-900 mb-4 sm:mb-6">
                  Para los niños
                </h3>
              </div>
              <div className="h-48 sm:h-56">
                <img
                  src="https://readdy.ai/api/search-image?query=gentle%20watercolor%20illustration%20happy%20child%20expressing%20emotions%20colorful%20feelings%20hearts%20stars%20playful%20artistic%20style%20warm%20pastel%20background%20simple%20minimalist%20design%20emotional%20intelligence%20self%20expression%20confidence%20joy%20authentic%20personality%20light%20tones&width=400&height=350&seq=children-benefits-001&orientation=portrait"
                  alt="Para los niños"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6 sm:p-8">
                <ul className="space-y-3 sm:space-y-4">
                  <li className="flex items-start gap-2 sm:gap-3">
                    <div className="w-6 h-6 flex items-center justify-center text-emerald-600 text-lg sm:text-xl flex-shrink-0">
                      <i className="ri-emotion-happy-line"></i>
                    </div>
                    <span className="text-gray-800 font-medium text-sm sm:text-base">Aprenden a reconocer y expresar sus emociones</span>
                  </li>
                  <li className="flex items-start gap-2 sm:gap-3">
                    <div className="w-6 h-6 flex items-center justify-center text-emerald-600 text-lg sm:text-xl flex-shrink-0">
                      <i className="ri-heart-3-line"></i>
                    </div>
                    <span className="text-gray-800 font-medium text-sm sm:text-base">Fortalecen su amor propio y confianza</span>
                  </li>
                  <li className="flex items-start gap-2 sm:gap-3">
                    <div className="w-6 h-6 flex items-center justify-center text-emerald-600 text-lg sm:text-xl flex-shrink-0">
                      <i className="ri-user-smile-line"></i>
                    </div>
                    <span className="text-gray-800 font-medium text-sm sm:text-base">Se sienten escuchados, validados y comprendidos</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* For Parents Card */}
            <div className="bg-white rounded-2xl sm:rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all hover:scale-105">
              <div className="p-6 sm:p-8 text-center">
                <h3 className="font-serif text-2xl sm:text-3xl font-bold text-gray-900 mb-4 sm:mb-6">
                  Para los padres
                </h3>
              </div>
              <div className="h-48 sm:h-56">
                <img
                  src="https://readdy.ai/api/search-image?query=soft%20watercolor%20illustration%20peaceful%20parent%20listening%20empathy%20understanding%20calm%20presence%20gentle%20artistic%20style%20warm%20pastel%20colors%20simple%20minimalist%20design%20emotional%20support%20patience%20mindful%20parenting%20serene%20atmosphere%20light%20background&width=400&height=350&seq=parents-benefits-001&orientation=portrait"
                  alt="Para los padres"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6 sm:p-8">
                <ul className="space-y-3 sm:space-y-4">
                  <li className="flex items-start gap-2 sm:gap-3">
                    <div className="w-6 h-6 flex items-center justify-center text-orange-600 text-lg sm:text-xl flex-shrink-0">
                      <i className="ri-lightbulb-line"></i>
                    </div>
                    <span className="text-gray-800 font-medium text-sm sm:text-base">Descubren herramientas simples para acompañar con empatía</span>
                  </li>
                  <li className="flex items-start gap-2 sm:gap-3">
                    <div className="w-6 h-6 flex items-center justify-center text-orange-600 text-lg sm:text-xl flex-shrink-0">
                      <i className="ri-ear-line"></i>
                    </div>
                    <span className="text-gray-800 font-medium text-sm sm:text-base">Aprenden a escuchar sin juzgar</span>
                  </li>
                  <li className="flex items-start gap-2 sm:gap-3">
                    <div className="w-6 h-6 flex items-center justify-center text-orange-600 text-lg sm:text-xl flex-shrink-0">
                      <i className="ri-leaf-line"></i>
                    </div>
                    <span className="text-gray-800 font-medium text-sm sm:text-base">Cultivan la calma incluso en momentos difíciles</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
